import Family from '@/models/Family'
import * as MutationTypes from './mutation_types'

const state = {
    family: Family.from(localStorage.token),
    isSubscriptionOpen: null,
    currentYear: {}
}

const getters = {
    currentFamily(state) {
        return state.family
    },
    isSubscriptionOpen(state) {
        return state.isSubscriptionOpen
    },
    currentYear(state){
        return state.currentYear
    }
}

const mutations = {
    [MutationTypes.LOGIN](state) {
        state.family = Family.from(localStorage.token)

    },
    [MutationTypes.LOGOUT](state) {
        state.family = null
    },

    UPDATE_SUBSCRIPTION: (state, value) => {
        state.isSubscriptionOpen = value
    },
    SET_CURRENT_YEAR: (state, value) =>  {
        state.currentYear = value
    }
    // UPDATE_FIRST_CONNECTION: (state, value) => {
    //     state.firstConnection = value
    // },
    // UPDATE_PROFILE_PICTURE: (state, defaultPicture, profilePicture) => {
    //     state.profile_picture = profilePicture
    //     state.default_picture = defaultPicture
    // }
}

const actions = {
    login({commit}) {
        commit(MutationTypes.LOGIN)
    },

    logout({commit}) {
        commit(MutationTypes.LOGOUT)
    },

    updateSubscription(store, value) {
        store.commit('UPDATE_SUBSCRIPTION', value)
    },

    setCurrentYear(store,  value) {
        store.commit('SET_CURRENT_YEAR', value)
    }

    // updateFirstConnection(store, value) {
    //     store.commit('UPDATE_FIRST_CONNECTION', value)
    // },
    // updateProfilePicture(store, defaultPicture, profilePicture) {
    //     store.commit('UPDATE_PROFILE_PICTURE', defaultPicture, profilePicture)
    // }
}

export default {
    state,
    mutations,
    actions,
    getters
}
